import { effect } from "../fmt";
import { Effect } from "./Effect";
import type { Ruleset, ShieldProfileData } from "./Ruleset";

export class ShieldProfile {
  ruleset: Ruleset;
  data: ShieldProfileData;

  constructor(ruleset: Ruleset, data: ShieldProfileData) {
    this.ruleset = ruleset;
    this.data = data;
  }

  get id() {
    return this.data.id;
  }

  get name() {
    return this.data.name;
  }

  get type() {
    return "SHIELD" as const;
  }

  get effects() {
    return (
      this.data.effects?.map((data) => Effect.from(this.ruleset, data)) ?? []
    );
  }

  get summary() {
    return this.effects.map(effect).join(" ");
  }
}
